export default __webpack_public_path__ + "static/media/M3_03.34c4b60b.jpg";